/* Scroll-scrubbed video.
   Based on the <scroll-video> element you supplied; adapted to sit inside the
   benefits diagram, so it measures against its own stage rather than a pinned
   full-height track. Requires an all-keyframe encode (-g 1) for exact seeks. */
(function () {
  if (customElements.get('aeloo-scroll-video')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class AelooScrollVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.track = this.closest('[data-scrub-track]') || this.parentElement;
      if (!this.video || !this.track) return;

      this.rotations = parseFloat(this.dataset.rotations) || 1;
      this.ease = parseFloat(this.dataset.ease) || 0.12;
      this.reverse = this.dataset.reverse === 'true';
      // Where in the clip the scrub begins, as a fraction of its duration.
      this.startAt = parseFloat(this.dataset.start) || 0;
      // The band of the viewport the stage scrubs across. Measuring from the
      // moment it peeks in at the bottom to the moment it leaves the top burns
      // half the clip before the stage is even properly on screen.
      this.winStart = parseFloat(this.dataset.winStart);
      this.winEnd = parseFloat(this.dataset.winEnd);
      if (isNaN(this.winStart)) this.winStart = 0.85;
      if (isNaN(this.winEnd)) this.winEnd = 0.15;

      this.duration = 0;
      this.progress = 0;
      this.target = 0;
      this.current = 0;
      this.rafId = null;

      var init = this.setup.bind(this);
      if (this.video.readyState >= 1) init();
      else this.video.addEventListener('loadedmetadata', init, { once: true });
    }

    setup() {
      this.duration = this.video.duration || 0;
      if (!this.duration || !isFinite(this.duration)) return;

      this.prime();
      this.measure();
      this.current = this.target =
        (this.startAt + this.progress * this.rotations) * this.duration;
      this.seek(this.current % this.duration);

      // Without motion, leave it on the first frame rather than animating.
      if (reduceMotion.matches) return;

      this.io = new IntersectionObserver(
        function (entries) {
          entries[0].isIntersecting ? this.start() : this.stop();
        }.bind(this),
        { rootMargin: '20% 0px 20% 0px' }
      );
      this.io.observe(this);
    }

    /* iOS refuses to seek until the element has been touched by playback once. */
    prime() {
      this.video.muted = true;
      var p = this.video.play();
      if (p && p.then) {
        p.then(
          function () {
            this.video.pause();
          }.bind(this)
        ).catch(function () {});
      } else {
        try {
          this.video.pause();
        } catch (e) {}
      }
    }

    start() {
      if (this.rafId) return;
      var loop = function () {
        this.measure();
        this.render();
        this.rafId = requestAnimationFrame(loop);
      }.bind(this);
      this.rafId = requestAnimationFrame(loop);
    }

    stop() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    /* 0 when the stage top reaches winStart of the viewport, 1 when its bottom
       reaches winEnd. The clip therefore runs while the stage is actually in
       view rather than spending itself on the approach. */
    measure() {
      var rect = this.track.getBoundingClientRect();
      var vh = window.innerHeight;
      var startY = vh * this.winStart;
      var endY = vh * this.winEnd;
      var total = startY - endY + rect.height;
      var p = total > 0 ? (startY - rect.top) / total : 0;
      p = Math.max(0, Math.min(1, p));
      this.progress = this.reverse ? 1 - p : p;
    }

    render() {
      this.target =
        (this.startAt + this.progress * this.rotations) * this.duration;
      var diff = this.target - this.current;
      this.current += Math.abs(diff) < 0.0005 ? diff : diff * this.ease;
      this.seek(this.current % this.duration);
    }

    seek(t) {
      var v = this.video;
      if (v.readyState < 2 || v.seeking) return;
      var clamped = Math.max(0, Math.min(this.duration - 0.001, t));
      if (Math.abs(v.currentTime - clamped) < 0.002) return;
      try {
        v.currentTime = clamped;
      } catch (e) {}
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
    }
  }

  customElements.define('aeloo-scroll-video', AelooScrollVideo);
})();
